import './scripts/common';
import {on, addClass, removeClass, closest} from "./libs/@elements/dom-utils";
import {onFind} from "./libs/@elements/init-modules-in-scope";

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]', function (element) {
    new Popover(element, {})
});

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as scrollingArea from './scripts/scrolling-area';
scrollingArea.init();

import * as loadBazaar from './scripts/load-bazaar';
loadBazaar.init();

import * as video from './scripts/video';
video.init();

import * as toggleOpen from './scripts/toggle-open';
toggleOpen.init();

import * as fetchModal from './scripts/fetch-modal';
fetchModal.init();

import * as affix from './libs/@elements/affix';
import {EVENTS} from "./libs/@elements/affix";
affix.init({mediaQuery: '(min-width: 768px)'});
onFind('.js-affix', ((affixElement) => {
    let isAffixBottomAllowed = closest('.js-affix__container', affixElement).getBoundingClientRect().top + closest('.js-affix__container', affixElement).getBoundingClientRect().height - 100 > affixElement.getBoundingClientRect().top + affixElement.getBoundingClientRect().height;

    on(EVENTS.AFFIX, (evt) => {
        if (!isAffixBottomAllowed) {
            removeClass('is-affix', evt.target)
        }
    }, affixElement);

    on(EVENTS.DETACH, (evt) => {
        let affixItem = evt.target;
        let container = closest('.js-affix__container', affixItem);

        removeClass('is-affix--bottom', evt.target);

        if (container.getBoundingClientRect().height + container.getBoundingClientRect().top + window.scrollY <= affixItem.getBoundingClientRect().top + affixItem.getBoundingClientRect().height + window.scrollY && isAffixBottomAllowed) {
            addClass('is-affix--bottom', affixItem);
        }
    }, affixElement);
}));

import * as squarelovin from './scripts/squarelovin';
squarelovin.init();

// import * as lightbox from './libs/@elements/lightbox';
// lightbox.init({zoom: true});

import * as pdsLightbox from './scripts/pdsLightbox';
pdsLightbox.init();

import * as notifyAvailability from './scripts/notifyAvailability';
notifyAvailability.init();

import * as floatingLabel from './libs/@elements/floating-labels';
app.floatingLabel = floatingLabel.init;
app.floatingLabel();

import * as formValidation from './scripts/form-validation';
app.formValidation = formValidation.init;

import * as productRating from './scripts/productRating';
productRating.init();

import * as productReviewAutoTranslate from './scripts/productReviewAutoTranslate';
productReviewAutoTranslate.init();

import * as pdsMicroVideos from './scripts/pdsMicroVideos';
pdsMicroVideos.init();

import * as friendlyCaptchaV1 from './scripts/friendlyCaptchaV1';
app.friendlyCaptchaV1 = friendlyCaptchaV1.init;
